export default {
      id: "oc-icon_shuttingdown-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_shuttingdown",
      toString: function () {
        return this.url;
      }
    }